import { Pagination } from '@mui/material';
import { TextAlignLeftIcon } from '@radix-ui/react-icons';
import { MoreHorizontal } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { ADD_COMMENTAIRE, DELETE_COMMENTAIRE, LIST_COMMENTAIRE } from '../../Utils/constant';
import { CommentaireForm } from '../../components/Forfait/CommentaireForm';
import { Loader } from '../../components/Widget/Loader';
import { deleteOne, store } from '../../services/service';
import { useCommentaireStore } from '../../store/CommentaireStore';

export const Commentaire = () => {
    const commentaire = useCommentaireStore()
    const [selectItem, setSelectItem] = useState(null)
    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);

    const submit = (data) => {
        setIsSubmit(true)
        store(ADD_COMMENTAIRE, 'application/json', data).then((res) => {
            setIsSubmit(false);
            if (res.status === 200) {
                reset();
                document.getElementById('fermer_create_trajet').click()
                toast.success('Commentaire ajouté')
                commentaire.getData(LIST_COMMENTAIRE, { page: 0, param: "", size: 10 }, '')
            }

        }).catch((err) => {
            document.getElementById('fermer_create_trajet').click()
            setIsSubmit(false)
            toast.error(err.response.data.donnee)
        })
    }

    useEffect(() => {
        commentaire.getData(LIST_COMMENTAIRE, { page: 0, param: "", size: 10 }, '')
    }, [])

    const more = (page) => {
        commentaire.getData(LIST_COMMENTAIRE, { page: page - 1, param: "", size: 10 }, '')
    }
    console.log(commentaire);

    return (
        <>
            <div>
                <div className='mt-4 lg:flex item-center '>
                    {/* <h1 className="text-2xl font-extrabold text-black">Type d'équipements</h1> */}
                    <input type="text" placeholder="Rechercher element..." className="input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
                    />
                    <div className='ml-auto'>
                        <button onClick={() => document.getElementById('add').showModal()} className="btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white" >
                            Ajouter un commentaire
                        </button>
                        <dialog id="add" className="modal ">
                            <div className="modal-box ">
                                <div className="modal-action">
                                    <h1 className='mr-auto text-2xl font-bold'>Ajouter un commentaire</h1>
                                    <form method="dialog">
                                        <button
                                            id="fermer_create_trajet"
                                            className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                                        >
                                            ✕
                                        </button>
                                    </form>
                                </div>
                                <form onSubmit={handleSubmit(submit)} className='px-2'>
                                    <div className='my-4 space-y-4'>
                                        <div className='my-2'>
                                            <label htmlFor="" className='text-sm font-medium'>Designation <span className="text-red-500">*</span></label>
                                            <input type="text" placeholder="" className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                                                {...register('designation', { required: true })} />
                                            {errors.designation && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                                        </div>

                                        <div className='my-2'>
                                            <label className="text-sm font-medium">Description</label>
                                            <textarea {...register('description')} className="textarea textarea-bordered w-full" placeholder='Description'></textarea>
                                        </div>

                                        <button type='submit'
                                            disabled={isSubmit}
                                            className={`${!isSubmit
                                                ? "text-black bg-main"
                                                : "text-slate-800 bg-slate-200 "
                                                } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                                        >
                                            {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
                                            {isSubmit ? (
                                                <span className="loading loading-dots loading-xs"></span>
                                            ) : null}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </dialog>
                    </div>
                </div>
                <dialog id="commentaire_upadate" className="modal ">
                    <div className="modal-box ">
                        <div className="modal-action">
                            <h1 className='mr-auto text-2xl font-bold'>Modification du commentaire</h1>

                            <form method="dialog">
                                <button
                                    id="fermer"
                                    className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                                >
                                    ✕
                                </button>
                            </form>
                        </div>
                        <CommentaireForm item={selectItem} />
                    </div>
                </dialog>
                <div className='grid md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5 gap-2 my-8'>
                    {
                        commentaire?.data?.data?.length === 0 ? 'Aucune donnée' :
                            commentaire?.data?.data?.length !== 0 && !commentaire?.loading ? (
                                commentaire?.data?.data?.map((item) => (
                                    <div className='relative flex gap-1 items-center cursor-pointer text-black shadow-sm border bg-white  rounded text-xs text-center'>
                                        <div className="dropdown dropdown-end absolute right-2 top-2">
                                            <div
                                                tabIndex={0}
                                                role="button"
                                                className="w-4 h-4 rounded-full flex items-center justify-center bg-gray-50"
                                            >
                                                <MoreHorizontal size={20} />
                                            </div>
                                            <ul
                                                tabIndex={0}
                                                className="mt-1 dropdown-content z-[1] menu p-2 border shadow bg-base-100 rounded-lg w-44"
                                            >
                                                <button
                                                    className="bg-white hover:bg-gray-100 text-gray-600 font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                                                    onClick={() => {
                                                        setSelectItem(item)
                                                        document.getElementById('commentaire_upadate').showModal()
                                                    }
                                                    }
                                                >
                                                    Modifier
                                                </button>
                                                <button
                                                    onClick={() => {
                                                        setSelectItem(item)
                                                        document.getElementById('delete').showModal()
                                                    }
                                                    }
                                                    className="bg-white hover:bg-red-600 text-black hover:text-white font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                                                >
                                                    Supprimer
                                                </button>

                                            </ul>
                                        </div>
                                        <div className='bg-gray-100 w-10 h-10 rounded m-1 flex items-center justify-center'>
                                            <TextAlignLeftIcon />
                                        </div>
                                        <div>
                                            <p className='font-bold truncate w-36'>{item?.designation}</p>
                                            <p className='truncate  w-28'>{item?.description}</p>
                                        </div>

                                    </div>

                                ))
                            ) : <Loader />
                    }

                </div>
                <div className='my-3 flex justify-end'>
                    <Pagination onChange={(event, newValue) => more(newValue)}
                        onSelect={selectedPage => more(selectedPage)} count={commentaire.count} variant="outlined" color='primary' shape="rounded" />
                </div>
                <dialog id="delete" className="modal">
                    <div className="modal-box max-w-md rounded-lg">
                        <h3 className="font-extrabold text-xl text-red-600 ">
                            Attention
                        </h3>
                        <p className="pt-2 text-black font-medium">
                            Voulez vous vraiment effectuer cette action ?
                        </p>
                        <div className="modal-action">
                            <form
                                method="dialog"
                                className="w-full flex items-center justify-end gap-x-4"
                            >
                                <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                    Annuler
                                </button>
                                <button onClick={() => {
                                    deleteOne(DELETE_COMMENTAIRE, selectItem.id).then(() => {
                                        commentaire.getData(LIST_COMMENTAIRE, { page: 0, param: "", size: 10 }, '')
                                        toast.success(`${selectItem.designation + ' supprimé'}`)
                                    }).catch((err) => {

                                    })
                                }} className="bg-red-600 text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                    Supprimer
                                </button>
                            </form>
                        </div>
                    </div>
                </dialog>
            </div>
        </>
    )

}
